import React from 'react';
import { Fish } from 'lucide-react';
import { EFFECTIVE, legalDocuments } from '../legal/legalContent.mjs';

/**
 * In-app copy of the privacy policy and account-deletion page. On the web,
 * nginx serves the static copy (public/legal/*.html, generated from the same
 * text) for these paths, so this only renders inside the store app and on the
 * dev server. The text itself lives in legal/legalContent.mjs.
 */

const docs = legalDocuments({
  entity: process.env.REACT_APP_LEGAL_ENTITY,
  contact: process.env.REACT_APP_LEGAL_CONTACT_EMAIL,
});

function LegalPage({ doc }) {
  return (
    <div className="min-h-[100dvh] bg-slate-50" style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}>
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-3xl items-center gap-2 px-5 py-4">
          <a href="/" className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-blue-600 to-cyan-500">
              <Fish className="h-4 w-4 text-white" />
            </span>
            <span className="font-semibold text-slate-900">Aqua ERP</span>
          </a>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-5 py-8" style={{ paddingBottom: 'calc(2rem + env(safe-area-inset-bottom, 0px))' }}>
        <h1 className="text-2xl font-bold text-slate-900">{doc.title}</h1>
        <p className="mt-1 text-sm text-slate-500">Effective {EFFECTIVE} · {doc.entity}</p>
        <div
          className="mt-6 space-y-4 text-[15px] leading-relaxed text-slate-700 [&_a]:text-blue-700 [&_a]:underline [&_h2]:pt-2 [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:text-slate-900 [&_li]:my-1.5 [&_ul]:list-disc [&_ul]:pl-5"
          // Static text from legalContent.mjs; the only interpolations are escaped there.
          dangerouslySetInnerHTML={{ __html: doc.html }}
        />
        <nav className="mt-10 flex gap-4 border-t border-slate-200 pt-4 text-sm">
          <a href="/privacy" className="text-blue-700 hover:underline">Privacy policy</a>
          <a href="/account-deletion" className="text-blue-700 hover:underline">Delete an account</a>
        </nav>
      </main>
    </div>
  );
}

export const PrivacyPolicy = () => <LegalPage doc={docs.privacy} />;
export const AccountDeletion = () => <LegalPage doc={docs.deletion} />;

export const LEGAL_ROUTES = {
  '/privacy': PrivacyPolicy,
  '/privacy-policy': PrivacyPolicy,
  '/account-deletion': AccountDeletion,
  '/delete-account': AccountDeletion,
};
